<template>

    <article class="ama">

        <h1>{{ $t('landing_consent_title_landing') }}</h1>

        <p>{{ $t('landing_consent_subtitle_description') }}</p>

        <button @click="instantApp">{{ $t('consent_cta_continue') }}</button>

    </article>

</template>

<script>

import Tag from '../../modules/tag'

export default {

    name: 'article-1-mobile-android',

    methods: {

        instantApp() {
            Tag.clickAll(this, 'continue_instant_app', undefined, 'landing')
            window.open('https://play.google.com/store/apps/details?id=io.cleanfox.android&launch=true', '_blank', 'rel="noopener,noreferrer,nofollow"')
        }
    }
}
</script>

<style lang="scss" scoped>

.ama {
    background-image: url("/img/background/fetch-mobile.svg");
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    background-color: $blue;
    padding: 100px 16px 156px;
    color: $charcoal;
    text-align: center;

    h1 {
        font-size: 28px;
        font-weight: bold;
        line-height: 1.14;
    }

    p {
        margin-top: 16px;
        font-size: 15px;
        line-height: 1.33;
    }

    button {
        width: 100%;
        margin-top: 48px;
        padding: 16px 40px;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.41;
        letter-spacing: normal;
        color: $white;
        border-radius: 32px;
        background-color: $midnight;
    }
}

</style>

